export default __webpack_public_path__ + "static/media/hht2_sitcom_07.819dba37.png";